import { VisibilityOff as VisibilityOffIcon } from '@mui/icons-material';
import { StatusPage } from 'cleveron-web-components';
import React from 'react';

function Error403({ id, translationKey }) {
    return (
        <StatusPage
            Icon={VisibilityOffIcon}
            buttonLink="/"
            buttonTextKey={
                translationKey ? `${translationKey}.actions.goToFrontPage` : 'actions.goToFrontPage'
            }
            id={id}
            textBottomKey={
                translationKey
                    ? `${translationKey}.accessRequiredText2`
                    : 'error.accessRequiredText2'
            }
            textTopKey={
                translationKey ? `${translationKey}.accessRequiredText` : 'error.accessRequiredText'
            }
            titleKey={translationKey ? `${translationKey}.accessRequired` : 'error.accessRequired'}
        />
    );
}

export default Error403;
